import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import SingleNews from "./SingleNews";
import ImageViewer from "../ImageViewer";
import { CloseIcon } from "../../Icons/icons.component";
import { httpPost } from "../../../utility/requestHelper";
import { envConfig } from "../../../constants/api-endpoint";
import ShareArticle from "../../Shared/ShareArticle";
import { isLoggedIn } from "../../../utility/common-methods";

function NewsDetails({
  isPrint,
  isOnline,
  setShowDetailsNews,
  selectedArticle,
  selectedArticleGrouped,
  setSelectedArticleGroup,
  setSelectedArticle,
  forEmbedArticles,
  clientId,
  isNewsDetailsMain,
  downloadParams,
  publication_type_id,
}) {
  const [imgSrcArray, setImageSrcArray] = useState([]);
  const [firstImageToShow, setFirstImageToShow] = useState(0);
  const [showImgViewer, setShowImgViewer] = useState(false);
  const history = useHistory();
  const [keywordsList, setKeywordsList] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // const getKeywordsTagsList = () => {
    //   if (isLoggedIn()) {
    //     return envConfig.KEYWORDS_TAGS_LIST;
    //   } else return envConfig.KEYWORDS_TAGS_LIST + "/1";
    // };
    try {
      if (selectedArticle && isOnline) {
        httpPost(`${envConfig.KEYWORDS_TAGS_LIST}`, {
          client_id: clientId || selectedArticle.Forclient_id,
          article_id: selectedArticle.article_id || selectedArticle.id,
          media_type: "online",
        }).then((response) => {
          const data = response.data.result.online;
          if (data && data.length) {
            setKeywordsList(data);
          }
        });
      }
    } catch (e) { }
  }, []);

  const handleImageZoom = (e, index, articleImages) => {
    setImageSrcArray(articleImages);
    setShowImgViewer(true);
    setFirstImageToShow(index);
  };

  return (
    <div>
      {showImgViewer && (
        <ImageViewer
          firstImageToShow={firstImageToShow}
          imgSrcArray={imgSrcArray}
          setShowImgViewer={setShowImgViewer}
          caption={selectedArticle.headline}
        />
      )}
      {forEmbedArticles && (
        <button
          className="closeNewsDetails"
          onClick={() => {
            setShowDetailsNews(false);
          }}
        >
          <CloseIcon />
        </button>
      )}
      <SingleNews
        setSelectedArticleGroup={setSelectedArticleGroup}
        setSelectedArticle={setSelectedArticle}
        selectedArticleGrouped={selectedArticleGrouped}
        handleImageZoom={handleImageZoom}
        setShowDetailsNews={setShowDetailsNews}
        newsDetails
        news={selectedArticle}
        isOnline={isOnline}
        isPrint={isPrint}
        forEmbedArticles={forEmbedArticles}
        keywordsList={keywordsList}
        isNewsDetailsMain={isNewsDetailsMain}
        downloadParams={downloadParams}
        clientId={clientId}
        publication_type_id={publication_type_id}
      />
    </div>
  );
}

export default NewsDetails;
